import { render, staticRenderFns } from "./MedicListItem.vue?vue&type=template&id=6f2369e2&scoped=true"
import script from "./MedicListItem.vue?vue&type=script&lang=js"
export * from "./MedicListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2369e2",
  null
  
)

export default component.exports